import { Component, input, output, signal } from "@angular/core";

import { LanguageDisplayNamePipe } from "@dcc/shared/ui-pipes";
import { locales } from "@dcc/shared/util-locale-manager";
import { VdsIconButtonComponent } from "@cce/design-system/button";
import { VdsIconComponent } from "@cce/design-system/icon";
import { VdsMenu, VdsMenuItemRadio, VdsMenuTrigger } from "@cce/design-system/menu";
import { VdsTooltipDirective } from "@cce/design-system/tooltip";

@Component({
    selector: "shell-ui-language-menu",
    templateUrl: "./language-menu.component.html",
    host: {
        class: "block"
    },
    imports: [
        VdsMenu,
        VdsMenuTrigger,
        VdsMenuItemRadio,
        VdsIconButtonComponent,
        VdsIconComponent,
        LanguageDisplayNamePipe,
        VdsTooltipDirective
    ]
})
export class LanguageMenuComponent {
    public readonly locales = signal(locales);

    public language = input.required<string>();
    public triggerLabel = input<string>();

    public languageChange = output<{ id: string; value: string }>();
}
